import React from "react";
import MatrimonyHeader from "../components/MatrimonyHeader";
import MatriMyProfileHero from "../components/MatriMyProfileHero";
import MatriRequest from "../components/MatriRequest";
import Footer from "../components/Footer";

function Request() {
  return (
    <div>
      <MatrimonyHeader />
      <MatriMyProfileHero />
      <MatriRequest />
      <Footer />
    </div>
  );
}

export default Request;
